module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sale2-577f6be4af3ac661d9918d6334faa283.svg";